import { render } from "./AddedToBag.vue?vue&type=template&id=82aa45fa&scoped=true"
import script from "./AddedToBag.vue?vue&type=script&lang=js"
export * from "./AddedToBag.vue?vue&type=script&lang=js"

import "./AddedToBag.vue?vue&type=style&index=0&id=82aa45fa&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82aa45fa"]])

export default __exports__